import React, { FC, memo } from 'react';
import styled from 'styled-components';
import Icon from '@minecraft.icon';
import { CoreTheme as theme } from '@minecraft.themes';

const Container = styled.div`
  display: flex;
  align-items: center;
`;

const StyledIcon = styled(Icon)`
  height: 1.125rem;
  width: 1.125rem;
  margin-right: 0.375rem;
  flex-shrink: 0;
`;

type Props = {
  height: string;
  weight: string;
};

const SummaryMeasurements: FC<Props> = ({ height, weight }) => {
  const anyMeasurementsExist = !!height || !!weight;
  const allMeasurementsExist = !!height && !!weight;

  return (
    anyMeasurementsExist && (
      <Container>
        <StyledIcon name="measurements" color={theme.colors.primary.darkGrey} />
        <div>
          {height}
          {allMeasurementsExist ? ' - ' : ''}
          {weight}
        </div>
      </Container>
    )
  );
};

export default memo<Props>(SummaryMeasurements);
